module.exports = __webpack_public_path__ + "img/TextBlock.72bc6e44.png";